<template>
    <div @click="ctrl_game.spinWheel()">
        <video id="background" muted autoplay loop src="assets/images/Background Loop.webm"></video>
        <div id="game">
            <div id="wheel-items">
                <div v-if="ctrl_game.currentPrize != null">
                    <transition-group enter-active-class="animate__animated animate__tada">
                        <img v-show="ctrl_game.currentPrizeIdx == idx" id="prize-image"
                            v-for="(prize, idx) in ctrl_prize.prizes" :key="prize.id" :src="prize.image.src" alt="">
                    </transition-group>
                </div>
                <!-- <img id="prize-image" src="assets/images/prize-tmp/Full Day.png" alt=""> -->
            </div>
        </div>
        <audio v-if="ctrl_game.playAudio" autoplay src="assets/audio/wheel.webm"></audio>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ctrl_game: this.ctrl_game(),
                ctrl_prize: this.ctrl_prize(),
            }
        },
        mounted() {
            screen.orientation.lock('landscape')
        }
    }
</script>